import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit {

  isLoggedIn = false;
  roles: string[] = [];
  showAdmin = false;
  constructor(private router: Router, private authGaurdService: AuthGaurdService,
    private msalService: MsalService) { }

  ngOnInit(): void {
  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  logout() {
    localStorage.removeItem('token');
    this.authGaurdService.isFavourite = true;
    this.msalService.logout();

    this.authGaurdService.signOut();

    this.isLoggedIn = false;
    this.roles = [];
    this.showAdmin = false;
  }

}
